import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToastService} from '../../toast-service';
import {AccountDefinition} from "../../../model/customer/account-definition";
import {CrystalclearCustomerBackUrl} from "../../config/crystalclear-customer-back-url";
import {BatchUpdateRequest} from "../../../model/api/batch-update-request";
import {Observable} from "rxjs";
import {ApiValidation} from "../../../model/api/api-validation";
import {CommonCrudService} from "../../common/common-crud.service";

@Injectable({
  providedIn: 'root'
})
export class CustomerAccountService extends CommonCrudService<AccountDefinition> {

  constructor(http: HttpClient,
              toastService: ToastService) {
    super(http,
      toastService,
      CrystalclearCustomerBackUrl.GET_CUSTOMER_ACCOUNT_LIST,
      CrystalclearCustomerBackUrl.SAVE_CUSTOMER_ACCOUNT,
      CrystalclearCustomerBackUrl.DELETE_CUSTOMER_ACCOUNT);
  }

  public saveBatch(request: BatchUpdateRequest<AccountDefinition>): Observable<ApiValidation<any>> {
    return this.post(CrystalclearCustomerBackUrl.SAVE_BATCH_CUSTOMER_ACCOUNT, request);
  }

  public cloneBatch(request: BatchUpdateRequest<AccountDefinition>): Observable<ApiValidation<any>> {
    return this.post(CrystalclearCustomerBackUrl.CLONE_BATCH_CUSTOMER_ACCOUNT, request);
  }

}
